// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input.input-style {
  background: transparent !important;
  color: #fff !important;
  border: 1px solid #ccc !important;
}

input.input-style::placeholder {
  color: #fff !important;
}
.login-label{
  color: #fff;
  font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Loginpage/loginpage.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,eAAe;AACjB","sourcesContent":["input.input-style {\r\n  background: transparent !important;\r\n  color: #fff !important;\r\n  border: 1px solid #ccc !important;\r\n}\r\n\r\ninput.input-style::placeholder {\r\n  color: #fff !important;\r\n}\r\n.login-label{\r\n  color: #fff;\r\n  font-size: 14px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
